import React from "react";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { Grid, FormHelperText } from "@material-ui/core";
import { useState, useEffect } from "react";
import TopicContain from "./_topic_contains";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
const useStyle = makeStyles((theme) => ({
    paddingSearch:{
        padding: "3% 2%",
        width: "100%",
    },
    input: {
      border: `1px solid ${theme.palette.eLight?.base}`,
      borderRadius: '1.625rem',
      height: '2rem',
      width: '100%'
    },
    topicContainSearch:{
      width:"100%",
      padding:"3% 2% 0% 2%"
    }
}));

export default function E_Card_Search(props) {
  let classes = useStyle();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 577px)" });
  const [keyword, setKeyword] = useState(props.searchWord);
  const [error, setError] = useState(false);
  const [showTopicContain, setShowTopicContain] = useState(false);
  const [topicContainSubtitleKeyword, setTopicContainSubtitleKeyword] = useState();
  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")
  let minWord = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_ALERTS_NOTIFICATION_SEARCH_MIN
  );
  let maxWord = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_ALERTS_NOTIFICATION_SEARCH_MAX
  );
  let warning_label = labelReady ? labels("E_METER_ALERTS_SEARCH_WARNING").replace(
    "{MIN_WORD}",
    minWord
  ) : <Skeleton />;

  useEffect(() => {
    if (props.searchWord !== keyword) {
      setKeyword(props.searchWord);
    }
  }, [props.searchWord]);

  useEffect(() => {
    if(keyword === "") {
      clearHandler();
    }
  }, [keyword])

  const handleSearchInputChange = (e) => {
    setKeyword(e.target.value);
  };

  const searchClickHandle = (e) => {
    e.preventDefault();
    if (keyword) {
      let words = keyword.split(" ");
      if (words.length >= minWord &&  words.length <= maxWord) {
        setError(false);
        props.getSearchData(keyword);
        setTopicContainSubtitleKeyword(keyword);
        setShowTopicContain(true);
      } else {
        setError(true);
      }
    } 
  };

  const keyPress = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      searchClickHandle();
    }
  };
  const clearHandler = () => {
    setKeyword("");
    setShowTopicContain(false);
    props.clearClicked(true);
  };
  return (
    <>
      <div className={showTopicContain ? classes.topicContainSearch:classes.paddingSearch}>
        <form onSubmit={searchClickHandle}>
          <Grid
            container
            justify="space-between"
            alignContent="center"
            alignItems="center"
            className={
              isTabletOrMobile
                ? error
                  ? classes.error
                  : classes.root
                : error
                ? classes.error1
                : classes.root1
            }
          >
            <InputBase
              onChange={(e) => handleSearchInputChange(e)}
              className={classes.input}
              value={keyword}
              placeholder={labelReady ? labels("E_ALERT_SEARCH_PLACEHOLDER") : ''}
              startAdornment={
                <IconButton
                  type="submit"
                  className={classes.iconButton}
                  aria-label="search"
                  onClick={searchClickHandle}
                  onKeyPress={keyPress}
                >
                  <SearchIcon />
                </IconButton>
              }
            ></InputBase>
          </Grid>
          {error ? (
            <FormHelperText className={classes.color}>
              {warning_label}
            </FormHelperText>
          ) : null}
          {showTopicContain && (
            <TopicContain
              searchWord={topicContainSubtitleKeyword}
              clearHandler={clearHandler}
            ></TopicContain>
          )}
        </form>
      </div>
    </>
  );
}